import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message, Icon } from 'nallian-shared-ui/lib/components';

const IdpUserGroupMessage = () => {
  const { t } = useTranslation();

  return (
    <Message negative icon>
      <Icon name="exclamation triangle" />
      <Message.Content>
        <Message.Header>{t('idpUserGroup')}</Message.Header>
        <p>{t('idpUserGroupInfo')}</p>
      </Message.Content>
    </Message>
  );
};

export default IdpUserGroupMessage;
